/**
 * Licensed Materials - Property of IBM
 * IBM Cognos Products: Dashboard
 * (C) Copyright IBM Corp. 2019, 2020
 * US Government Users Restricted Rights - Use, duplication or disclosure restricted by GSA ADP Schedule Contract with IBM Corp.
 */

// Used to generate the requirejs layers bundle
// Only declare the entry points, not all modules!
define([
	'./lassoSelectAction/LassoSelectAction',
	'./jumpToAction/JumpToAction',
	'./changeVisTypeAction/ChangeVisTypeAction',
	'./suppressionAction/SuppressionAction',
	'./suppressionAction/SuppressionPropertyProvider',
	'./conditionalFormatting/api/impl/DeprecatedConditionalFormatting',
	'./renderSequence/RenderSequenceFeature',
	'./queryResultOverride/QueryResultOverride',
	'./queryResultOverride/DataTaskOverride',
	'./expandCollapseAction/ExpandCollapsePropertyProvider'
], () => {});
